<template>
  <section class="row align-items-center">
    <div class="col-lg-6">
      <img :src="mainImage?mainImage.url:''" alt="Members Ancestry Kit" class="img-fluid w-100 w-lg-auto mb-3 mb-lg-0">
    </div>
    <div class="col-lg-6 order-lg-first" v-html="mainDescription">
    </div>
  </section>
</template>
<script setup>
import { defineProps } from 'vue';
  defineProps({
    mainDescription: {
      type: String,
      required: true,
    },
    mainImage: {
      type: Object,
      required: true,
    },
  });
</script>